<template>
  <div class="extend-item">
    <div class="item-title">{{ title }}</div>
    <div class="item-content">
      <div class="item-content-no">
        <div style="font-size: 16px">
          {{ info.tradeApplyInfoVO.applyNumber }}
        </div>
        <div class="item-content-date">
          <span>{{ extendOrderInfo.execWeek }}次</span>
          <span style="padding-left: 20px">
            {{
              extendOrderInfo.orderStartTime | parseTime("{y}-{m}-{d}", true)
            }}-
            {{ extendOrderInfo.orderEndTime | parseTime("{y}-{m}-{d}", true) }}
          </span>
        </div>
      </div>
      <div class="item-content-status">
        {{ applyStatusName }}
      </div>
      <div class="item-content-btn" @click="handleOrderInfo">查看详情</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'perfect-extend-item',
  props: {
    title: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default: null
    },
    perfectInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    extendOrderInfo () {
      if (!this.info && !this.info.tradeApplyExecPerfectVOList) return
      return this.info.tradeApplyExecPerfectVOList[0]
    },
    applyStatusName () {
      if (!this.extendOrderInfo) return
      if (this.info.tradeApplyInfoVO.applyStatus === '0') return '待提交'
      if (this.info.tradeApplyInfoVO.applyStatus === '100') return '待审批'
      if (this.info.tradeApplyInfoVO.applyStatus === '300') {
        if (!this.info.tradeApplyBaseVO.isStack) return '已禁用'
        if (this.extendOrderInfo.orderStartTime > +new Date()) return '未开始'
        return '执行中'
      }
      if (this.info.tradeApplyInfoVO.applyStatus === '500') return '已完成'
      if (this.info.tradeApplyInfoVO.applyStatus === '900') return '已关闭'
      return ''
    }
  },
  methods: {
    handleOrderInfo () {
      this.$router.push({
        path: '/trade/perfect-order-info',
        query: {
          applyId: this.info.tradeApplyInfoVO.applyId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.extend-item {
  width: 48%;
  .item-title {
    font-size: 16px;
    font-weight: bold;
    padding-left: 3px;
    padding-bottom: 5px;
  }
  .item-content {
    background-color: #f9f9f9;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    & > div {
      flex-shrink: 0;
    }
    .item-content-no {
      .item-content-date {
        margin-top: 10px;
        font-size: 14px;
        color: #999;
      }
    }
    .item-content-btn {
      color: $base-blue;
      cursor: pointer;
    }
  }
}
</style>
